/**
 * Case- and diacritics-insensitive normalization for substring search.
 *
 * Czech names make this mandatory, not cosmetic: a bare `toLowerCase().includes()`
 * never matches "Černý" for the query "cerny", so admins could not find their own
 * members. Lifted out of DataTable so every search surface shares one behaviour.
 */
export const normalizeText = (s: string): string =>
  s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

/** Diacritics-insensitive substring test. */
export const matchesQuery = (haystack: string, needle: string): boolean =>
  normalizeText(haystack).includes(normalizeText(needle));

/** Locale-aware name comparator; use for any user-visible A→Z list. */
export const compareNames = (a: string, b: string): number =>
  a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true });
